<template>
  <ExternalQueryList
      endpoint="/api/v2/portals"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => false"
      :can-update="() => false"
      @show="portal => $router.push(getUrl(portal))"
  >
    <template v-slot:default="{ row: portal }">
      <td>
        <router-link :to="getUrl(portal)">
          {{ portal.attributes.name }}
        </router-link>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Name'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(portal) {
      return '/portals/' + portal.id + '/content'
    }
  }
}
</script>
